import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router";
import {Button, Grid, Typography} from "@mui/material";
import './KoiFacade.scss'
import {HelpComponent} from "../help-component/HelpComponent";
import {ChevronLeft} from "@mui/icons-material";

type ButtonSpec = {
    type: 'btn'
    link: string
    label: string
} | {
    type: 'component'
    node: React.ReactNode
}

type Props = {
    // avatar?: React.ReactNode;
    title: string | React.ReactNode;
    subTitle?: string | React.ReactNode;
    intro?: React.ReactNode;
    back?: string | false | ButtonSpec;
    backLabel?: string;
    backClass?: string;
    onBack?: () => void;
    next?: ButtonSpec;
    nextClass?: string;
    helpContent?: React.ReactNode;
    simpleAction?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
}

export const KoiFacade: React.FC<Props> = observer((
    {
        children,
        title,
        subTitle,
        back,
        backLabel,
        backClass,
        onBack,
        next,
        nextClass,
        intro,
        helpContent,
        simpleAction,
        className
    }) => {
    const navigate = useNavigate();
    const titleColWidth = 10 - (next ? 2 : 0);
    const hasSubtitle = Boolean(subTitle);
    return (
        <div className={"koi-facade" + (className ? ` ${className}` : '')}>
            <Grid container className="header" alignItems="center">
                <Grid size={2} className={backClass ?? 'text-center'}>
                    {(back === undefined || typeof back === 'string')
                        ? <Button
                            color="primary"
                            variant="outlined"
                            startIcon={<ChevronLeft/>}
                            onClick={() => onBack ? onBack() : navigate('' + back)}>
                            {backLabel === undefined ? 'Back' : backLabel}
                        </Button>
                        : typeof back === 'object'
                            ? (back.type === 'component'
                                ? back.node
                                : <Button
                                    color="primary"
                                    variant="outlined"
                                    startIcon={<ChevronLeft/>}
                                    onClick={() => navigate('' + back.link)}>
                                    {back.label === undefined ? 'Next' : back.label}
                                </Button>)
                            : null
                    }
                </Grid>
                <Grid className="title-container" size={titleColWidth}>
                    {typeof title === 'string' ?
                        <Typography variant="h2" component={hasSubtitle ? 'div' : 'h1'} className="page-title">
                            {title}
                            {helpContent ? <HelpComponent helpContent={helpContent}/> : <></>}
                            {simpleAction}
                            {hasSubtitle && typeof subTitle === 'string' &&
                                <Typography variant="h4" component="h4" className="taxonomy-title">
                                    {subTitle}
                                </Typography>
                            }
                        </Typography>
                        : title
                    }
                    {subTitle && typeof subTitle !== 'string' ? subTitle : false}
                </Grid>
                {next &&
                    <Grid size={2} className={nextClass ?? 'text-center'}>
                        {next?.type === 'btn' &&
                            <Button
                                color="primary"
                                variant="contained"
                                // startIcon={<ArrowBack/>}
                                onClick={() => navigate('' + next.link)}>
                                {next.label === undefined ? 'Next' : next.label}
                            </Button>
                        }
                        {next?.type === 'component' && next.node}
                    </Grid>
                }
            </Grid>
            {intro &&
                <Grid container>
                    <Grid size={2}/>
                    <Grid className="intro" size={10}>
                        {intro}
                    </Grid>
                </Grid>
            }
            {children}
        </div>
    );
});
